import checkout from "./form";

const {
  formField: {
    fullName,
    chiefAccountant,
    signer,
    timeSign,
    accountingService,
    certificate,

    taxpayersName,
    taxpayersId,

    taxAgentName,
    taxAgentId,

    tctm,
    bctc,
    htldl,
    auditOpinion,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [chiefAccountant.name]: "",
  [accountingService.name]: "",
  [certificate.name]: "",

  [taxpayersName.name]: "",
  [taxpayersId.name]: "",

  [taxAgentName.name]: "",
  [taxAgentId.name]: "",

  [tctm.name]: "",
  [bctc.name]: "",
  [htldl.name]: "",
  [auditOpinion.name]: "",
};

export default initialValues;
